<template lang="">
	<div>
    <button @click="closeForm">
      <img style="width: 40px" src="../../../../static/images/close-grey.svg" />
    </button>
    <ValidationObserver v-slot="{ invalid }">
      <div>
        <v-card class="mt-8 mx-8">
          <div width="550" class="d-flex flex-column px-8 py-8">
            <div class="d-flex flex-column mr-8" >
            <ValidationProvider
              class="form-group"
              rules="required"
              v-slot="{ errors }"
            >
              <label class="font-weight-black">Copy*</label>
              <input
                v-model="item.copy_name"
                type="text"
                class="inputCopy mt-3"
                name="nome da copy"
              >
              <span class="input-error">
                {{ errors[0] }} 
              </span>
            </ValidationProvider>
            </div>
            <div class="d-flex flex-column mt-7">
              <label class="font-weight-black">Produto</label>
              <!-- <span>{{item.product.product_name}}</span> -->
              <ValidationProvider
                class="form-group"
                rules="required"
                v-slot="{ errors }"
                name="produto"
              >
                <v-select
                  v-model="selected"
                  placeholder="Produto"
                  label="product_name"
                  class="b-4 mt-3 h-48 pt-2"
                  :options="productItems.data"
                  :value="item.product.product_name"
                >
              </v-select>
              <span class="input-error">
                {{ errors[0] }} 
              </span>
              </ValidationProvider>
            </div>
            <div class="d-flex flex-row align-center mt-7">
              <label class="font-weight-black mr-2">Status</label>
              <v-switch
                v-model="item.copy_is_active"
                color="var(--blue)"
                inset
                class="mt-3"
                :disabled="!item.copy_id"
                :options="options"
              ></v-switch>
            </div>
          </div>
        </v-card>
        <v-btn
          class="mt-4 ml-8"
          height="62"
          width="95"
          color="var(--red)"
          @click="onSubmit"
          :disabled="invalid"
        >
          Enviar
        </v-btn>
      </div>
    </ValidationObserver>

    <div class="d-flex justify-center">
      <v-snackbar 
        v-model="openError"
        :timeout="timeout"
        color="var(--red)"
        top
      >
        <span style="color: var(--white)">{{ errorMessage }}</span>
      </v-snackbar>
    </div>
	</div>
</template>
<script>
// Lib
import { mapActions, mapState, mapMutations } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

import VueCookies from 'vue-cookies'

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
  },
	data () {
		return {
      disabled: true,
      selected: {},
      options: [
        {
          value: 'true',
          text: 'Ativo'
        },
        {
          value: 'false',
          text: 'Inativo'
        }
      ],
      openError: false,
      timeout: 3000,
      errorMessage: ''
    }
  },
  created () {
    this.selected = this.item.product
  },
  computed: {
    ...mapState('Product', {
      productItems: 'items'
    }),
    ...mapState('Copy', {
      item: 'copyToEdit',
      loading: 'loading'
    }),
  },
  methods: {
    ...mapActions('Copy', [
      'postCopy',
      'updateCopy',
      'getCopies',
      'disableCopy'
    ]),
    ...mapMutations('Copy', {
      unsetCopyToEdit: 'UNSET_COPY_TO_EDIT',
      setLoading: 'SET_LOADING'
    }),
    ...mapMutations('Shared', {
      setToaster: 'SET_TOASTER'
    }),
    updateCopyProduct(option) {
      let selectedProduct = this.productItems.data.filter(product => product.product_id === option)[0]
      this.item.product = {
        ...this.item.product,
        ...selectedProduct
      }
    },
    validate () {
      if (
        !this.checkCopy() &&
        this.checkProduct()
      ) {
        this.toaster(
          'Erro na validação',
          'red',
          true
        )
      }
    },
    checkCopy () {
      return this.item.copy_name.length > 0
    },
    checkProduct () {
      return this.item.product.product_id !== null
    },
    async onSubmit () {
      this.setLoading(true)
  
      const token = VueCookies.get('jwt-login')

      await this.handleSendCopyInfo(token)
      await this.getCopies({token: token})
      this.setLoading(false)
    },
    async handleSendCopyInfo(token) {
      if (this.item.copy_id) {
        await this.handleUpdate(token)
      } else {
        await this.handlePost(token)
      }
    },
    async handlePost(token) {
      try {
        const response = await this.postCopy([
          {
            copy_name: this.item.copy_name,
            product: {
              product_id: this.selected.product_id
            }
          },
          token
        ])
        if (response.status >= 400) {
          throw new Error(response.data.message)
        } else {
          this.toaster(
            'Copy cadastrado com sucesso',
            'var(--green)',
            true
          )
          this.closeForm()
          window.scrollTo(0, 0)
        }
      } catch (error) {
        this.openError = true
        this.errorMessage = error.message
      }
    },
    async handleUpdate(token) {
      try {
        const response = await this.updateCopy([
          {
            ...this.item,
            copy_name: this.item.copy_name,
            copy_is_active: JSON.parse(this.item.copy_is_active),
            product: {
              product_id: this.selected.product_id,
            }
          },
          token
        ])
        if (!JSON.parse(this.item.copy_is_active)) {
          await this.disableCopy([
            this.item,
            token
          ])
        }
        if (response.status >= 400) {
          throw new Error(response.data.message)
        } else {
          this.toaster(
            'Copy atualizado com sucesso',
            'var(--green)',
            true
          )
        }
        this.closeForm()
        window.scrollTo(0, 0)
      } catch (error) {
        this.openError = true
        this.errorMessage = error.message
      }
    },
    toaster(message, color, visible) {
      this.setToaster({
        message,
        color,
        visible
      })
    },
    closeForm () {
      this.unsetCopyToEdit()
      this.$emit('close')
    },
  },
  watch: {
    'item.product.product_id' () {
      this.validate()
    },
    'item.product' () {
      this.selected = this.item.product.product_name
    }
  }
}
</script>
<style lang="scss" scoped>
	.inputCopy {
    border: 2px solid var(--grey-day-030);
    border-radius: 4px;
    width: 492px; 
    height: 48px;
    padding: 15px;
    background: transparent;
    font-family: var(--dm-sans-regular);
    color: var(--grey);
  }
  .v-overlay__scrim {
    height: 200%
  }
  .h-48 {
    height: 48px;
  }
</style>


// WEBPACK FOOTER //
// src/components/Contents/AutomaticsTriggers/CopyForm.vue